export default __webpack_public_path__ + "b3dacbbaad1becd4ea2cdf7470aa78a0.jpg";